import Requisicao from "./RequisicaoService";

class FormasPagamentoService {            
    static async listar() {
        return Requisicao.get('formas-pagamento');
    }    

    static async buscar(id) {
        return Requisicao.get('formas-pagamento/' + id);
    }

    static async gravar(dados) {
        return Requisicao.post('formas-pagamento', dados);
    }

    static async remover(id) {        
        return Requisicao.delete('formas-pagamento/' + id);
    }

    static async formaPagamentoNotExists(id, id_modalidade, qtde_parcelas, compras_acima_de) {
        return Requisicao.get('formas-pagamento/not-exists/' + id + '/' + id_modalidade + '/' + qtde_parcelas + '/' + compras_acima_de);
    }
}

export default FormasPagamentoService;